import { useEffect, useState } from 'react';
import axios from 'axios';
import ReactGA from 'react-ga4';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { IS_LOCAL, TRACKING_DISABLED } from '../Utils/environment';

/**
 * Public IP used for the session when running locally.
 *
 * The server reads the visitor's country from the connection, falls back to the address the client
 * sends when that address is private, and localhost is always private. Without this the fallback
 * would be the developer's own connection, which puts every local lead outside the countries the
 * funnel treats as its main audience and makes the Prime journey untestable.
 *
 * Override it with VITE_DEV_CLIENT_IP to walk the Foreign or Junk branches instead.
 */
const LOCAL_IP_ADDRESS = import.meta.env.VITE_DEV_CLIENT_IP || '8.8.8.8';

export const useUserTracking = () => {
  const [ipAddress, setIpAddress] = useState(null);
  const [GAId, setGAId] = useState(null);
  const [fingerprintId, setFingerprintId] = useState(null);

  // get IP address
  useEffect(() => {
    // locally the address is fixed, which also avoids the call to the ipify service
    if (IS_LOCAL) return setIpAddress(LOCAL_IP_ADDRESS);

    axios
      .get('https://api.ipify.org')
      .then(({ data }) => setIpAddress(data))
      .catch((error) => console.log(error));
  }, []);

  // get FingerprintJS visitorId
  useEffect(() => {
    const getFingerprintId = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setFingerprintId(result.visitorId);
    };

    getFingerprintId();
  }, []);

  // Get rawGA cause we need prefix "GA1.1" ??
  useEffect(() => {
    // without Analytics initialised nothing answers the client-id request, so the callback would
    // never fire; the session is created with a null ga_id, which the server already expects
    if (TRACKING_DISABLED) return;

    ReactGA.ga(() => {
      const rawGA = document.cookie
        .split('; ')
        .find((c) => c.startsWith('_ga='))
        ?.split('=')[1];

      setGAId(rawGA);
    });
  }, []);

  return { ipAddress, GAId, fingerprintId };
};
